import React from "react";

// Component for the main title of the website
const WebsiteTitle = () => {
  // Will maybe make this a logo at some point?

  return (
    <div className="m-4">
      <h1 className="text-6xl font-raleway text-slate-600 drop-shadow-md">
        Troy Tomasch
      </h1>
    </div>
  );
};

export default WebsiteTitle;
